import { useEffect, useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import ChatInput from './ChatInput';
import './ChatPage.css';

const ChatWindow = ({
  user,
  project,
  messages,
  setMessages,
  setProjects,
  setSelectedProject,
  loading,
  setLoading,
}) => {
  const [userInfo, setUserInfo] = useState({ name: '', company: '' });
  const [isCreative, setIsCreative] = useState(true);

  useEffect(() => {
    const fetchUserInfo = async () => {
      if (user?.uid) {
        const docRef = doc(db, 'users', user.uid);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const data = docSnap.data();
          setUserInfo({
            name: data.name || '',
            company: data.company || '',
          });
        }
      }
    };

    fetchUserInfo();
  }, [user]);

  const handleCreativeToggle = () => {
    setIsCreative(!isCreative);
  };

  return (
    <div className="chat-window">
      <div className="chat-header">
        <h1>{project ? project.title : ''}</h1>
        {/*{project && (
          <div className="creative-toggle">
            <span className="toggle-label">Teknik Bilgi Desteği:</span>
            <div
              className={`creative-toggle-button ${isCreative ? 'on' : 'off'}`}
              onClick={handleCreativeToggle}
            >
              {isCreative ? 'AÇIK' : 'KAPALI'}
            </div>
          </div>
        )}*/}
      </div>

      <div className="chat-body">
        {project ? (
          <div className="chat-main">
            <div className="chat-history">
              {messages.map((msg, idx) => (
                <div
                  key={idx}
                  className={`chat-bubble ${msg.sender === 'user' ? 'user' : 'bot'}`}
                >
                  {msg.text}
                </div>
              ))}
              {loading && (
                <div className="chat-bubble bot">ProWA düşünüyor...</div>
              )}
            </div>
            <ChatInput
              user={user}
              project={project}
              messages={messages}
              setMessages={setMessages}
              setProjects={setProjects}
              setSelectedProject={setSelectedProject}
              loading={loading}
              setLoading={setLoading}
              creative={isCreative}
            />
          </div>
        ) : (
          <div className="chat-placeholder">
            <div>
              Hoşgeldin {userInfo.name} ({userInfo.company})
            </div>
            <div>
               <br/>
            </div>
            <div>
              Başlamak için Projelerinizden Seçin veya Yeni Proje Yaratın.
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ChatWindow;
